import { Sentry } from '@xingternal/hops';

const onlyOnProduction = (callback) => {
  if (process.env.NODE_ENV === 'production') {
    callback();
  }
};

const setSentryUserInfo = ({ id, email }) => {
  onlyOnProduction(() =>
    Sentry.configureScope((scope) => {
      scope.setUser({ id, email });
    }),
  );
};

const captureException = (error) => {
  onlyOnProduction(() => Sentry.captureException(error));
};

export { setSentryUserInfo, captureException };
